import { render } from "./head.vue?vue&type=template&id=adc40932&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=adc40932&scoped=true&lang=scss"

import exportComponent from "/Users/yangshaohua/work/workspace/school-b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc40932"]])

export default __exports__